import ReactDOM from 'react-dom';

interface PortalProps {
  children: JSX.Element;
  node?: any
}

const Portal = ({children, node}: PortalProps) => {
  const _node = node || document.body;
  return (
    <>
      {ReactDOM.createPortal(children, _node)}
    </>
  );
};

export default Portal;